import {
  Box,
  Grid,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getTeamUserPerfomance } from '../../../../redux/features/poinTrackerSlice';
import NoDataFound from '../../../../components/NodataIndication/NoDataFound';
import Loader3D from '../../../../components/Loader/Loader3D';

const TeamsUserPerfomance = ({ fromDate, toDate, selectedTeam }) => {
  const [limit, setLimit] = useState(10);
  const teamUserPerfomance = useSelector((state) => state.pointTracker.teamUserPerfomance);
  const { responseData, loading } = teamUserPerfomance;
  const teamUserPerfomanceApiData = responseData;

  const dispatch = useDispatch();
  const dispatchParams = useMemo(() => {
    return {
      fromDate,
      toDate,
      wingId: selectedTeam.id === -1 ? null : selectedTeam.id,
    };
  }, [fromDate, toDate, selectedTeam.id]);
  const previousDispatchParams = useRef(dispatchParams);
  const isApiNeeded = JSON.stringify(previousDispatchParams.current) !== JSON.stringify(dispatchParams);

  useEffect(() => {
    if (Object.entries(teamUserPerfomance?.responseData || {}).length === 0 || isApiNeeded) {
      dispatch(getTeamUserPerfomance(dispatchParams));
      previousDispatchParams.current = dispatchParams;
    }
  }, [dispatch, dispatchParams, teamUserPerfomance?.responseData, isApiNeeded]);

  const projects = teamUserPerfomanceApiData?.meta?.projects || [
    {
      id: 2,
      value: 'Foundation',
    },
    {
      id: 1,
      value: 'Classroom',
    },
    {
      id: 3,
      value: 'Little Genie',
    },
  ];

  const subHeaders = [
    { key: 'sales', label: 'Sales' },
    { key: 'revenue', label: 'Revenue' },
    { key: 'adm', label: 'Adm' },
  ];

  const data = teamUserPerfomanceApiData?.data?.slice(0, limit) || [];
  const noDataFound = Boolean(data?.length === 0);

  return (
    <Box>
      <Typography fontWeight={600} mb={2}>
        Team User Performance - VS
      </Typography>

      {/* TABLE */}
      <Paper elevation={5}>
        <Box sx={{ overflowX: 'auto', backgroundColor: 'white', borderRadius: { xs: '10px', md: '10px' } }}>
          {loading ? (
            <Loader3D />
          ) : noDataFound ? (
            <NoDataFound />
          ) : (
            <Table
              size="small"
              sx={{
                borderCollapse: 'collapse',
                border: '1px solid #a5a5a5',

                '& th, & td': {
                  border: '1px solid #a5a5a5',
                  padding: '6px 10px',
                },
              }}
            >
              <TableHead>
                {/* MAIN HEADER */}
                <TableRow>
                  <TableCell
                    rowSpan={2}
                    sx={{
                      backgroundColor: '#334155',
                      color: '#fff',
                      fontWeight: 700,
                      minWidth: 250,
                      textAlign: 'center',
                    }}
                  >
                    User
                  </TableCell>

                  {projects.map(({ value: header, id: projectId }, index) => (
                    <TableCell
                      key={header}
                      colSpan={subHeaders.length}
                      align="center"
                      sx={{
                        backgroundColor: '#334155',
                        color: '#fff',
                        fontWeight: 700,
                        textAlign: 'center',
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>

                {/* SUB HEADER */}
                <TableRow>
                  {projects.map(({ value: header }) =>
                    subHeaders.map((sub) => (
                      <TableCell
                        key={`${header}-${sub.key}`}
                        align="center"
                        sx={{
                          backgroundColor: '#e2e8f0',
                          color: '#0f172a',
                          fontWeight: 600,
                        }}
                      >
                        {sub.label}
                      </TableCell>
                    )),
                  )}
                </TableRow>
              </TableHead>

              <TableBody>
                {data.map((row) => (
                  <TableRow
                    key={row.userId}
                    sx={{
                      '&:nth-of-type(even)': {
                        backgroundColor: '#f8fafc',
                      },
                      '&:hover': {
                        backgroundColor: '#eef2ff',
                      },
                    }}
                  >
                    <TableCell sx={{ fontWeight: 600 }}>{row.userName}</TableCell>

                    {projects.map(({ value: header, id: projectId }) =>
                      subHeaders.map((sub) => (
                        <TableCell key={`${row.userId}-${header}-${sub.key}`} align="center">
                          {row?.[sub.key]?.[projectId] ?? 0}
                        </TableCell>
                      )),
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Box>
        <Box p={1}>
          {/* DROP DOWN SECTION */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Select
              size="small"
              value={limit}
              onChange={(e) => setLimit(e.target.value)}
              sx={{
                ml: 1,
                height: 32,
                fontSize: 12,
                '& .MuiSelect-select': { py: 0.5, px: 1 },
              }}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={200}>200</MenuItem>
              <MenuItem value={500}>500</MenuItem>
            </Select>

            <Typography variant="caption" fontSize={12}>
              {`${limit} / ${responseData?.data?.length}`}
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default TeamsUserPerfomance;
